import React from 'react';
import { IPaymentDetailsProps } from '@components/Sura/PaymentDetails/types';
import Card from '@material-ui/core/Card';
import useStyles from '@components/Sura/PaymentDetails/styles';
import { observer } from 'mobx-react';
import useStore from '@hooks/useStore';
import HeaderTotal from '@components/Sura/PaymentDetails/HeaderTotal';
import Contracts from '@components/Sura/PaymentDetails/Contracts';

const PaymentDetails: React.FC<IPaymentDetailsProps> = () => {
  const { ui } = useStore();
  const css = useStyles({ isMobile: ui.isMobileScreen });

  return (
    <div className={css.divCard}>
      <Card className={css.card}>
        <HeaderTotal />
        <Contracts />
      </Card>
    </div>
  );
};

export default observer(PaymentDetails);
